// Whether a product card offers its RBP links (RBP-D33). SL1.0 decides it in one listing loop
// (`www/engine/get_smanager.php:3829-3877`); SL2 holds its facts in two places. The server sends
// `rbpLinks`: `OFFERED` (an off-sale core parent with a child the caller can order) or
// `IF_OUT_OF_STOCK` (an on-sale one where the live stock check runs). This is the check's other
// half, over what the card already composes: a price row (a priced quote) and a numeric stock
// level (an availability entry; a product with no stock row has none, so the supplier flag alone
// never counts) that is out of stock or carries the supplier's unavailable flag.

import type { RbpLinksOffer } from '../api/browse.client';
import type { AvailabilityEntry } from '../availability/useAvailabilityStore';
import type { PriceEntry } from '../pricing/usePriceStore';

export interface RbpLinksFacts {
  readonly availability: AvailabilityEntry | undefined;
  readonly price: PriceEntry | undefined;
  readonly isPickedFresh: boolean;
}

export function showsRbpLinks(offer: RbpLinksOffer | undefined, facts: RbpLinksFacts): boolean {
  if (offer === 'OFFERED') return true;
  if (offer !== 'IF_OUT_OF_STOCK') return false;
  // The server never sends the check for a picked-fresh product; refuse it here too.
  if (facts.isPickedFresh) return false;
  if (facts.price?.state !== 'priced') return false;
  const stock = facts.availability;
  if (stock === undefined) return false;
  return stock.band === 'OUT_OF_STOCK' || stock.status === 'UNAVAILABLE';
}
